import { SpecialFeeApplicationMode } from "@/common/types/establishment/company.type";
import { strategyToOptions } from "@/common/utils/strategyToOptions";

export const specialFeeApplicationMode: Record<SpecialFeeApplicationMode, string> = {
  apply_only_income_tax: 'Aplicar apenas imposto de renda',
  apply_all: 'Aplicar todas',
}

export const specialFeeApplicationModeOptions = strategyToOptions(specialFeeApplicationMode);
